export default "__VITE_ASSET__CAY9y4Vo__"